import { CONTEXT_KEY } from 'api/api-constants';
import { getAPI } from 'api/api-common';

export const CURRENT_SELECTED_PROJECT_ID_SESSION_KEY =
  'current-selected-project-id';

export const getSelectedProjectApiClient = () => {
  const projectGeo = getGeo({
    contextKey: CONTEXT_KEY.SELECTED_PROJECT_CONTEXT,
  });
  return getAPI(projectGeo);
};

export const getProjectApiClient = (projectID) => {
  const projectGeo = getGeo({
    contextKey: CONTEXT_KEY.PROJECT_CONTEXT,
    contextValue: projectID,
  });
  return getAPI(projectGeo, parseInt(projectID));
};

export const getHomeGeoApiClient = () => {
  const homeGeo = getGeo({
    contextKey: CONTEXT_KEY.HOME_GEO_CONTEXT,
  });
  return getAPI(homeGeo);
};

export const getSelectedGeoApiClient = (geoCode) => {
  return getAPI(geoCode);
};

export const getCurrentGeoApiClient = () => {
  const currentGeo = window.TIEOUT.ENV.CURRENT_GEO;
  return getAPI(currentGeo);
};

const getGeoByProjectId = (projectID) => {
  const projectToGeoMapString = localStorage.getItem('project_to_geo_map');
  const projectToGeoMapArray = JSON.parse(projectToGeoMapString);
  const projectToGeoMap = new Map(projectToGeoMapArray);
  return (projectToGeoMap.get(projectID) || {}).geoCode;
};

export const getGeo = ({ contextKey, contextValue }) => {
  switch (contextKey) {
    case CONTEXT_KEY.SELECTED_PROJECT_CONTEXT: {
      const selectedProjectID = localStorage.getItem('selected_project_id');
      const projectGeo = getGeoByProjectId(selectedProjectID);
      return projectGeo;
    }

    case CONTEXT_KEY.PROJECT_CONTEXT: {
      const projectGeo = getGeoByProjectId(contextValue);
      return projectGeo;
    }

    case CONTEXT_KEY.HOME_GEO_CONTEXT: {
      const homeGeo = localStorage.getItem('home_geo');
      return homeGeo;
    }

    // case CONTEXT_KEY.STATEMENT_CONTEXT:
    //   return 'GEO_1';

    // case CONTEXT_KEY.REVISION_CONTEXT:
    //   return window.TIEOUT.ENV.CURRENT_GEO;

    // case CONTEXT_KEY.CURRENT_GEO_CONTEXT:
    //   return window.TIEOUT.ENV.CURRENT_GEO;

    default:
      return window.TIEOUT.ENV.CURRENT_GEO;
  }
};
